import { sendAIFCExperienceTrackingToParent } from './index';

const REMIX_REGENERATE_EXPERIENCE = 'aiMateRemixRegenerate';

type RemixRegenerateExperienceMetadata = {
	remixType?: string;
	remixSubtype?: string;
};

export const remixRegenerateExperience: {
	start: () => void;
	success: (args?: RemixRegenerateExperienceMetadata) => void;
	fail: (args: { error: string } & RemixRegenerateExperienceMetadata) => void;
	abort: (args: { reason: string }) => void;
} = {
	start: () =>
		sendAIFCExperienceTrackingToParent({
			status: 'start',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
		}),
	success: (args) =>
		sendAIFCExperienceTrackingToParent({
			status: 'success',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			...(args?.remixType && { remixType: args.remixType }),
			...(args?.remixSubtype && { remixSubtype: args.remixSubtype }),
		}),
	fail: ({ error, remixType, remixSubtype }) =>
		sendAIFCExperienceTrackingToParent({
			status: 'fail',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			error,
			...(remixType && { remixType }),
			...(remixSubtype && { remixSubtype }),
		}),
	abort: ({ reason }) =>
		sendAIFCExperienceTrackingToParent({
			status: 'abort',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			reason,
		}),
};
